import "./App.css";
import { Link } from "react-router-dom";

function ApplicationHomepage() {
  return (
    <div className="flex flex-col min-h-screen">
      <div className="bgImg fixed"></div>
      <div className="flex-1 relative z-10">
        <div className="pt-20 pb-16">
          <div className="max-w-6xl mx-auto px-6">
            {/* Header Section */}
            <div className="text-center mb-12">
              <h1 className="text-5xl font-bold text-zinc-200 mb-4 mt-6 text">
                Join <span className="text-amber-500">Omnicraft SMP</span>
              </h1>
              <p className="text-xl text-zinc-100 max-w-2xl mx-auto leading-relaxed">
                Choose the application that best describes your status with our
                community. Please read the descriptions carefully before
                proceeding.
              </p>
            </div>

            {/* Application Cards */}
            <div className="grid lg:grid-cols-2 gap-8 max-w-5xl mx-auto">
              {/* New Member Card */}
              <div className="bg-zinc-900/95 border border-zinc-700/50 rounded-xl shadow-2xl hover:shadow-amber-500/10 transition-all duration-300 overflow-hidden group hover:border-amber-600/30">
                <div className="p-8">
                  <div className="flex items-center mb-6">
                    <div className="bg-gradient-to-r text-green-500 from-green-500 to-emerald-500 px-4 py-2 rounded-lg font-bold text-lg mr-4 shadow-lg">
                      NEW
                    </div>
                    <div className="h-px bg-gradient-to-r from-green-500/50 to-transparent flex-1"></div>
                  </div>

                  <h2 className="text-2xl font-bold text-zinc-200 mb-3">
                    New Member Application
                  </h2>

                  <p className="text-zinc-400 mb-6 leading-relaxed">
                    Perfect for players who are completely new to the Omnicraft
                    SMP community. This application covers all the basics we
                    need to know about you and your Minecraft experience.
                  </p>

                  <div className="bg-green-500/10 border border-green-500/20 rounded-lg p-4 mb-6">
                    <div className="flex items-start">
                      <svg
                        className="w-5 h-5 text-green-400 mt-0.5 mr-3 flex-shrink-0"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                      >
                        <path
                          fillRule="evenodd"
                          d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
                          clipRule="evenodd"
                        />
                      </svg>
                      <div>
                        <p className="text-green-300 font-medium text-sm">
                          For New Members Only
                        </p>
                        <p className="text-green-200/80 text-sm mt-1">
                          If you were previously a member, please use the Former
                          Member application instead.
                        </p>
                      </div>
                    </div>
                  </div>

                  <Link
                    to="/new-member-application"
                    className="block w-full bg-gradient-to-r from-green-600 to-emerald-600 hover:from-green-500 hover:to-emerald-500 text-white font-semibold py-3 px-6 rounded-lg text-center transition-all duration-200 transform hover:scale-105 shadow-lg"
                  >
                    Start New Member Application
                  </Link>
                </div>
              </div>

              {/* Former Member Card */}
              <div className="bg-zinc-900/95 border border-zinc-700/50 rounded-xl shadow-2xl hover:shadow-amber-500/10 transition-all duration-300 overflow-hidden group hover:border-amber-600/30">
                <div className="p-8">
                  <div className="flex items-center mb-6">
                    <div className="bg-gradient-to-r from-orange-500 to-amber-500 text-amber-500 px-4 py-2 rounded-lg font-bold text-lg mr-4 shadow-lg">
                      FORMER
                    </div>
                    <div className="h-px bg-gradient-to-r from-orange-500/50 to-transparent flex-1"></div>
                  </div>

                  <h2 className="text-2xl font-bold text-zinc-200 mb-3">
                    Former Member Application
                  </h2>

                  <p className="text-zinc-400 mb-6 leading-relaxed">
                    Designed for players who were previously part of the
                    Omnicraft SMP community and wish to return. This application
                    includes specific questions about your previous membership.
                  </p>

                  <div className="bg-orange-500/10 border border-orange-500/20 rounded-lg p-4 mb-6">
                    <div className="flex items-start">
                      <svg
                        className="w-5 h-5 text-orange-400 mt-0.5 mr-3 flex-shrink-0"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                      >
                        <path
                          fillRule="evenodd"
                          d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z"
                          clipRule="evenodd"
                        />
                      </svg>
                      <div>
                        <p className="text-orange-300 font-medium text-sm">
                          For Former Members Only
                        </p>
                        <p className="text-orange-200/80 text-sm mt-1">
                          New members using this application will be
                          automatically denied.
                        </p>
                      </div>
                    </div>
                  </div>

                  <Link
                    to="/former-member-application"
                    className="block w-full bg-gradient-to-r from-orange-600 to-amber-600 hover:from-orange-500 hover:to-amber-500 text-white font-semibold py-3 px-6 rounded-lg text-center transition-all duration-200 transform hover:scale-105 shadow-lg"
                  >
                    Start Former Member Application
                  </Link>
                </div>
              </div>
            </div>

            {/* Additional Information */}
            <div className="mt-16 text-center">
              <div className="bg-zinc-900/90 border border-zinc-700/50 rounded-xl p-8 max-w-5xl mx-auto shadow-xl">
                <h3 className="text-2xl font-bold text-amber-400 mb-4">
                  Important Notes
                </h3>
                <div className="grid md:grid-cols-2 gap-6 text-left">
                  <div>
                    <h4 className="font-semibold text-zinc-200 mb-2">
                      📝 Application Process
                    </h4>
                    <p className="text-zinc-400 text-sm">
                      All applications are carefully reviewed by our
                      administration team. Please provide detailed and honest
                      answers to ensure the best chance of acceptance.
                    </p>
                  </div>
                  <div>
                    <h4 className="font-semibold text-zinc-200 mb-2">
                      ⏱️ Response Time
                    </h4>
                    <p className="text-zinc-400 text-sm">
                      We typically respond to applications within 3-5 business
                      days. You'll receive a notification on Discord with the
                      status.
                    </p>
                  </div>
                  <div>
                    <h4 className="font-semibold text-zinc-200 mb-2">
                      💬 Questions?
                    </h4>
                    <p className="text-zinc-400 text-sm">
                      If you have any questions about the application process,
                      feel free to reach out to Owen on our Discord server.
                    </p>
                  </div>
                  <div>
                    <h4 className="font-semibold text-zinc-200 mb-2">
                      🔄 Reapplication
                    </h4>
                    <p className="text-zinc-400 text-sm">
                      If your application is denied, you may reapply 1 time and
                      fix any issues regarding your answers. Please address any
                      feedback provided in your new application.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default ApplicationHomepage;
